<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('administration.employee.employeeProfile.employeeProfile') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('administration.employee.employeeProfile.employeeProfile'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="ts-flex">
          <div class="ts-flex">
            <ts-button
              color="info"
              outline
              @click="$router.push({ name: 'employee-create' })"
              >{{ $t('employee.addNew') }}</ts-button
            >
            <div
              class="ml-2 ts-rounded ts-border ts-px-2 ts-whitespace-no-wrap mr-2"
              style="width: 245px"
            >
              <div class="radio radio-css radio-inline">
                <input
                  v-model="side"
                  type="radio"
                  id="front"
                  :value="'front'"
                />
                <label for="front">
                  {{ $t('administration.employee.employeeProfile.front') }}
                </label>
              </div>
              <div class="radio radio-css radio-inline">
                <input v-model="side" type="radio" id="back" :value="'back'" />
                <label for="back">
                  {{ $t('administration.employee.employeeProfile.back') }}
                </label>
              </div>
              <!-- Old Preview Card  -->
              <ts-button
                v-if="true"
                class="btn-sm ml-2 mr-3"
                :disabled="!checkedEmp.length > 0"
                outline
                color="primary"
                @click="previewCard('simple')"
              >
                {{ $t('administration.employee.employeeProfile.previewCard') }}
              </ts-button>
            </div>
            <!-- New Preview Card -->
            <div class="ts-mr-2" v-if="false">
              <b-dropdown
                dropdown
                :text="
                  $t(
                    'school.academic.operation.profile_mgt.studentProfile.previewCard'
                  )
                "
                variant="primary"
              >
                <b-dropdown-item
                  :disabled="!checkedEmp.length > 0"
                  href="#"
                  @click="previewCard('simple')"
                >
                  <i class="fas fa-print"></i>
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.studentProfile.simplePrinter'
                    )
                  }}
                </b-dropdown-item>
                <b-dropdown-item
                  :disabled="!checkedEmp.length > 0"
                  href="#"
                  @click="previewCard('pro')"
                >
                  <i class="fas fa-id-card"></i>
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.studentProfile.proPrinter'
                    )
                  }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
            <b-dropdown
              dropdown
              :text="$t('administration.employee.employeeProfile.exportExcel')"
              variant="outline-success"
              :waiting="exporting"
            >
              <b-dropdown-item
                :disabled="!checkedEmp.length > 0"
                href="#"
                @click="exportExcelSelectedEmployee"
              >
                <i class="fas fa-check-square"></i>
                {{
                  $t('administration.employee.employeeProfile.selectedEmployee')
                }}
              </b-dropdown-item>
              <b-dropdown-item href="#" @click="exportExcelAllTeacher">
                <i class="fas fa-users"></i>
                {{ $t('administration.employee.employeeProfile.allEmployee') }}
              </b-dropdown-item>
            </b-dropdown>
          </div>
          <div class="ts-flex-grow"></div>
          <select class="form-control" style="width: 120px" v-model="status">
            <option v-for="status in statuses" :value="status">
              {{ status }}
            </option>
          </select>
          <div class="ml-2 mr-2">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 300px"
            />
          </div>
          <ts-button
            outline
            v-tooltip="$t('filter')"
            @click.prevent="visible = true"
          >
            <i class="fa fa-filter"></i>
          </ts-button>
        </div>
        <!-- </div> -->
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :showCheckbox="true"
          @check-items="checkItem"
        >
          <template v-slot="{ record }">
            <td class="text-center with-img">
              <img
                class="height-30 ts-rounded"
                v-lazy="{
                  src: photoEmp(record),
                  error: onError(record),
                  loading: require('@/assets/Rolling-1s-200px_2.svg')
                }"
              />
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.branch !== null ? record.branch.branch_name_en : '' }}
            </td>
            <td class="text-center ts-whitespace-no-wrap">
              {{ record.emp_id }}
            </td>
            <td class="ts-whitespace-no-wrap">{{ record.name_kh }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.name_en }}</td>
            <td class="text-center ts-whitespace-no-wrap">
              <span v-if="record.gender == 1">{{ $t('employee.male') }}</span>
              <span v-else>{{ $t('employee.female') }}</span>
            </td>
            <td class="ts-whitespace-no-wrap">{{ record.date_of_birth }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.phone_number_1 }}</td>
            <td class="ts-whitespace-no-wrap">
              {{
                record.position !== null
                  ? $store.getters.limitStringShow(
                      record.position.pos_name_en,
                      25
                    )
                  : ''
              }}
            </td>
            <td class="text-center ts-whitespace-no-wrap">
              {{
                record.shift
                  ? record.shift.shift_name +
                    ' (' +
                    record.shift.shift_type +
                    ') '
                  : ''
              }}
            </td>
            <td class="text-center ts-whitespace-no-wrap">
              <span
                class="badge badge-success"
                v-if="record.status == 'Active'"
                >{{ $t('employee.active') }}</span
              >
              <span
                class="badge badge-danger"
                v-if="record.status == 'Resigned'"
                >{{ $t('employee.resigned') }}</span
              >
              <span
                class="badge badge-warning"
                v-if="record.status == 'Terminated'"
                >{{ $t('employee.terminated') }}</span
              >
              <span
                class="badge badge-info"
                v-if="record.status == 'Suspend'"
                >{{ $t('employee.suspend') }}</span
              >
              <span
                class="badge badge-secondary"
                v-if="record.status == 'Cancelled'"
                >{{ $t('employee.cancelled') }}</span
              >
            </td>
            <td class="ts-whitespace-no-wrap">
              {{
                record.created_by
                  ? record.created_by.employee
                    ? record.created_by.employee.name_en
                    : record.created_by.loginname
                  : ''
              }}
            </td>
            <td class="text-center ts-whitespace-no-wrap">
              {{ record.created_date }}
            </td>
            <td class="ts-text-center">
              <a-popconfirm
                placement="leftTop"
                :title="$t('are_you_sure_to_increase')"
                :ok-text="$t('yes')"
                :cancel-text="$t('no')"
                @confirm="increaseCounter(record)"
              >
                <a
                  href="#"
                  class="ts-border ts-rounded-full ts-px-2 ts-h-1 ts-bg-teal-500 ts-text-white"
                >
                  <i
                    class="fas fa-circle-notch spin"
                    v-if="record._deleting"
                  ></i>
                  <span v-else>
                    {{
                      record.card_print_counter ? record.card_print_counter : 0
                    }}
                  </span>
                </a>
              </a-popconfirm>
            </td>
            <td class="text-center ts-whitespace-no-wrap">
              <a
                href="#"
                title="Transfer"
                class="mr-2 text-primary"
                @click.prevent="transfer(record)"
              >
                <i class="fas fa-exchange-alt"></i>
              </a>
              <a
                href="#"
                title="Show"
                class="mr-2 text-info"
                @click.prevent="show(record)"
              >
                <i class="fas fa-eye"></i>
              </a>
              <a
                href="#"
                title="Edit"
                class="mr-2 text-primary"
                @click.prevent="edit(record)"
              >
                <i class="fas fa-edit"></i>
              </a>
              <a
                href="#"
                title="Delete"
                class="text-danger mr-1"
                @click.prevent="destroy(record)"
                :disabled="record._deleting"
              >
                <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                <i class="fas fa-trash" v-else></i>
              </a>
              <b-dropdown
                size="xs"
                variant="link"
                toggle-class="text-decoration-none"
                no-caret
                right
                v-tooltip="$t('administration.employee.employeeProfile.card')"
              >
                <template slot="button-content">
                  <i class="fas fa-id-card"></i>
                </template>
                <b-dropdown-item @click="card(record, 'front')">
                  <i class="fas fa-address-card"></i>
                  {{ $t('administration.employee.employeeProfile.frontCard') }}
                </b-dropdown-item>
                <b-dropdown-item @click="card(record, 'back')">
                  <i class="far fa-credit-card"></i>
                  {{ $t('administration.employee.employeeProfile.backCard') }}
                </b-dropdown-item>
              </b-dropdown>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-between align-items-center p-15">
        <ts-total-list v-model="pagination" />
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-card>
    <!-- drawer -->
    <a-drawer
      :title="$t('invoice.filter')"
      placement="right"
      :closable="false"
      :visible="visible"
      @close="() => (visible = false)"
      :zIndex="1020"
      width="300px"
    >
      <div style="font-size: 12px">
        <div class="row">
          <div class="form-group">
            <a-select
              style="width: 257px"
              v-model="branch_id"
              :options="branchs"
              showSearch
              mode="multiple"
              :filterOption="
                (input, option) =>
                  option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
              "
              :maxTagCount="1"
              :maxTagTextLength="17"
              :placeholder="$t('all')"
            >
            </a-select>
          </div>
        </div>
        <div class="row">
          <legend class="text-black ts-text-sm">Card Activation</legend>
          <div class="form-group">
            <div class="radio radio-css radio-inline is-valid">
              <input
                v-model="id_card_activated"
                type="radio"
                id="activated"
                :value="'yes'"
              />
              <label for="activated"> Activated </label>
            </div>
            <div class="radio radio-css radio-inline is-invalid">
              <input
                v-model="id_card_activated"
                type="radio"
                id="no_activated"
                :value="'no'"
              />
              <label for="no_activated"> Not Yet Activate </label>
            </div>
          </div>
        </div>
        <div class="row">
          <legend class="text-black ts-text-sm">Photo Upload</legend>
          <div class="form-group">
            <div class="radio radio-css radio-inline is-valid">
              <input
                v-model="photo_exists"
                type="radio"
                id="uploaded"
                :value="'yes'"
              />
              <label for="uploaded"> Uploaded </label>
            </div>
            <div class="radio radio-css radio-inline is-invalid">
              <input
                v-model="photo_exists"
                type="radio"
                id="no_upload"
                :value="'no'"
              />
              <label for="no_upload"> Not Yet Upload </label>
            </div>
          </div>
        </div>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import { debounce, trim } from 'lodash'
import { mapState } from 'vuex'
import PreviewCard from './preview-card'
import * as FileDownload from 'downloadjs'
import TransferComponent from './transfer.vue'
export default {
  name: 'employee',
  components: { TransferComponent },
  data () {
    return {
      loading: false,
      exporting: false,
      side: 'front',
      checkedEmp: [],
      visible: false,
      branchs: [],
      manPhoto: require('../../assets/staff-default-man.png'),
      womenPhoto: require('../../assets/staff-default-women.png'),
      columns: [
        {
          name: this.$t('employee.photo'),
          style: 'text-align:center; width: 3%'
        },
        { name: this.$t('employee.branch'), style: 'width: 9%' },
        { name: this.$t('employee.id'), style: 'text-align:center; width: 8%' },
        { name: this.$t('employee.nameKh'), style: 'width: 12%' },
        { name: this.$t('employee.nameEn'), style: 'width: 12%' },
        {
          name: this.$t('employee.gender'),
          style: 'text-align:center; width: 3%'
        },
        {
          name: this.$t('employee.dateofbirth'),
          style: 'text-align:center; width: 5%'
        },
        { name: this.$t('employee.phone'), style: 'width: 6%' },
        { name: this.$t('employee.position') },
        {
          name: this.$t('employee.shift'),
          style: 'text-align:center; width: 6%'
        },
        { name: this.$t('employee.status'), style: 'text-align:center' },
        { name: this.$t('employee.createdBy') },
        { name: this.$t('employee.createdDate'), style: 'text-align:center' },
        {
          name: this.$t('employee.cardCounter'),
          style: 'text-align:center; width:5%'
        },
        { name: this.$t('employee.actions'), style: 'text-align:center' }
      ]
    }
  },
  created () {
    this.branch_id = [this.$store.state.authUser.default_branch_id]
    this.fetchResourceBeforeCreate()
    this.fetchData()
    this.getBranch()
  },
  computed: {
    ...mapState('employee', ['resources', 'pagination', 'statuses']),
    search: {
      get () {
        return this.$store.state.employee.search
      },
      set (newValue) {
        this.$store.commit('employee/SET_SEARCH', newValue)
        this.$store.commit('employee/RESET_CURRENT_PAGE')
      }
    },
    id_card_activated: {
      get () {
        return this.$store.state.employee.id_card_activated
      },
      set (newValue) {
        this.$store.commit('employee/SET_ID_CARD_ACTIVATED', newValue)
      }
    },
    photo_exists: {
      get () {
        return this.$store.state.employee.photo_exists
      },
      set (newValue) {
        this.$store.commit('employee/SET_PHOTO_EXISTS', newValue)
      }
    },
    status: {
      get () {
        return this.$store.state.employee.status
      },
      set (newValue) {
        this.$store.commit('employee/SET_STATUS', newValue)
      }
    },
    branch_id: {
      get () {
        return this.$store.state.employee.branch_id
      },
      set (newValue) {
        this.$store.commit('employee/SET_BRANCH_ID', newValue)
      }
    },
  },
  methods: {
    increaseCounter (record) {
      record._deleting = true
      this.$store
        .dispatch('employee/increasePrinterCardCounter', record.staff_id)
        .then(response => {
          record.card_print_counter = record.card_print_counter + 1
          this.$toasted.success(response.message)
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          record._deleting = false
        })
    },
    fetchResourceBeforeCreate () {
      this.$store
        .dispatch('employee/dataBeforeCreate')
        .then(() => {})
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch(
          'employee/fetch',
          Object.assign(
            {
              branch_id: this.branch_id
            },
            { ...attributes }
          )
        )
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    getBranch () {
      this.$store
        .dispatch('user/getBranch', {
          filter: {
            user_branches: true
          }
        })
        .then(response => {
          this.branchs = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
    },
    edit (record) {
      this.$store.commit('employee/SET_FOUND_DATA', record)
      this.$router.push({
        name: 'employee-edit',
        params: { id: record.staff_id }
      })
    },
    show (record) {
      this.$store.commit('employee/SET_FOUND_DATA', record)
      this.$router.push({
        name: 'employee-show',
        params: { id: record.staff_id }
      })
    },
    async destroy (record) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        record._deleting = true
        this.$store
          .dispatch('employee/destroy', record.staff_id)
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    },
    checkItem (value) {
      this.checkedEmp = []
      if (!_.isEmpty(value)) {
        value.forEach(element => {
          this.checkedEmp.push(element.staff_id)
        })
      }
    },
    previewCard (type) {
      this.$modal.show(
        PreviewCard,
        {
          id_list: this.checkedEmp,
          side: this.side,
          type: type
        },
        {
          height: 'auto',
          width: '70%',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    },
    excel (record) {
      this.checkedEmp = []
      this.checkedEmp.push(record.staff_id)
      this.exportExcelSelectedEmployee()
      this.checkedEmp = []
    },
    exportExcelAllTeacher () {
      this.checkedEmp = []
      this.exportExcelSelectedEmployee()
    },
    exportExcelSelectedEmployee () {
      this.exporting = true
      this.$store
        .dispatch('employee/exportExcel', {
          staff_id: this.checkedEmp,
          branch_id: this.branch_id
        })
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.$toasted.error(error.message)
        })
        .finally(() => (this.exporting = false))
    },
    card (record, side) {
      this.checkedEmp = []
      this.checkedEmp.push(record.staff_id)
      this.side = side
      this.previewCard()
      this.checkedEmp = []
    },
    photoEmp (record) {
      if (record.photo) {
        return record.photo
      }

      return record.gender == 1 ? this.manPhoto : this.womenPhoto
    },

    onError (record) {
      event
        ? (event.target.src =
            record.gender == 1 ? this.manPhoto : this.womenPhoto)
        : ''
    },
    transfer (record) {
      this.$modal.show(
        TransferComponent,
        {
          value: record
        },
        {
          height: 'auto',
          scrollable: true,
          clickToClose: false
        }
      )
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({
        search,
        branch_id: this.branch_id,
        id_card_activated: this.id_card_activated,
        status: this.status,
        photo_exists: this.photo_exists
      })
    }, 500),
    id_card_activated: debounce(function (id_card_activated) {
      this.fetchData({
        id_card_activated,
        branch_id: this.branch_id,
        status: this.status,
        photo_exists: this.photo_exists
      })
    }, 500),
    photo_exists: debounce(function (photo_exists) {
      this.fetchData({
        photo_exists,
        status: this.status,
        branch_id: this.branch_id,
        id_card_activated: this.id_card_activated
      })
    }, 500),
    status: debounce(function (status) {
      this.fetchData({
        status,
        branch_id: this.branch_id,
        id_card_activated: this.id_card_activated,
        photo_exists: this.photo_exists
      })
    }, 500),
    branch_id: debounce(function (value) {
      this.fetchData({ branch_id: value })
    }, 500)
  },
  beforeRouteLeave (to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'employee-create') {
      this.$store.commit('employee/RESET_STATE')
      this.$store.commit('employee/SET_POSITIONS', [])
      this.$store.commit('employee/SET_STATUSES', [])
      this.$store.commit('employee/SET_PROVINCES', [])
      this.$store.commit('employee/SET_DISTRICTS', [])
      this.$store.commit('employee/SET_COMMUNES', [])
      this.$store.commit('employee/SET_VILLAGES', [])
      this.$store.commit('employee/SET_ID_TYPES', [])
      this.$store.commit('employee/SET_SPOUSE_OCCUPATIONS', [])
      this.$store.commit('employee/SET_DIVISIONS', [])
      this.$store.commit('employee/SET_DEPARTMENTS', [])
      this.$store.commit('employee/SET_EMPLOYEES', [])
      this.$store.commit('employee/SET_SHIFTS', [])
    }
    next()
  }
}
</script>
<style lang="scss" scoped>
table td {
  vertical-align: middle;
}

::-webkit-scrollbar {
  height: 8px;
  width: 3px;
  /* Remove scrollbar space */
  background: #ffff;
  /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #e5e7e7;
}

div::-webkit-scrollbar-thumb:hover {
  background: #b7b7b8;
}
</style>
